import {
  IntermediateAndFinishedProductsClassificationInputNames,
  MaterialType
} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'

import {useMaterialsClassificationMetadata} from '../../../hooks'
import {MaterialsGrid} from '../components/MaterialsGrid'
import {MaterialsGridItem} from '../components/MaterialsGridItem'

import {ClassificationAutocomplete} from './inputs/ClassificationAutocomplete'
import {ClassificationTextField} from './inputs/ClassificationTextField'

interface IntermediateAndFinishedProductsClassificationProps {
  isDisabled: boolean
}

export const IntermediateAndFinishedProductsClassification: React.FC<
  IntermediateAndFinishedProductsClassificationProps
> = ({isDisabled}) => {
  const {data: metadata} = useMaterialsClassificationMetadata(
    MaterialType.IntermediateAndFinishedProducts
  )

  if (!metadata) {
    throw new Error(
      'BUG: classification metadata should be loaded before rendering classification tab'
    )
  }

  return (
    <MaterialsGrid {...dataTestId('intermediate_and_finished_products_classification_form')}>
      <MaterialsGridItem>
        <ClassificationAutocomplete
          materialType={MaterialType.IntermediateAndFinishedProducts}
          inputName={IntermediateAndFinishedProductsClassificationInputNames.Selection}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationTextField
          materialType={MaterialType.IntermediateAndFinishedProducts}
          inputName={IntermediateAndFinishedProductsClassificationInputNames.LegacyId}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
    </MaterialsGrid>
  )
}
